/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum PrivacyAliases {
  CARD_PRIVACY_WARNING = 'card-privacy-warning',
  CARD_TERM = 'card-term',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  CONTEXTUAL_BAR_1 = 'contextual-bar-1',
  CONTEXTUAL_BAR_TERM = 'contextual-bar-term',
  FETCH_0 = 'fetch-0',
  FETCH_PRIVACY_WARNING = 'fetch-privacy-warning',
  FETCH_STATUS = 'fetch-status',
  FETCH_STATUS_TERM = 'fetch-status-term',
  FETCH_TERM = 'fetch-term',
  FIELD_PRIVACY_WARNING_TEXT = 'field-privacy-warning-text',
  FIELD_TERM = 'field-term',
  FIELD_TERM_TEXT = 'field-term-text',
  FIELD_TERM_VALIDITY = 'field-term-validity',
  FIELD_WARNING = 'field-warning',
  FIELD_WARNING_VALIDITY = 'field-warning-validity',
  FORM_0 = 'form-0',
  FORM_1 = 'form-1',
  HPMS_DYNAMIC_CONTENT_FIELD = 'hpms-dynamic-content-field',
  HPMS_DYNAMIC_CONTENT_FIELD_TERM = 'hpms-dynamic-content-field-term',
  HPMS_TEXT_HTML_2 = 'hpms-text-html-2',
  HPMS_TEXT_HTML_PRIVACY_WARNING = 'hpms-text-html-privacy-warning',
  HPMS_TEXT_HTML_TERM = 'hpms-text-html-term',
  LAYOUT_0 = 'layout-0',
  MODAL_DESCRIPTION = 'modal-description',
  PANEL_0 = 'panel-0',
  PANEL_1 = 'panel-1',
  PANEL_2 = 'panel-2',
  PANEL_MODAL_DESCRIPTION = 'panel-modal-description',
  PANEL_PRIVACY_WARNING = 'panel-privacy-warning',
  PANEL_PRIVACY_WARNING_TEXT = 'panel-privacy-warning-text',
  PANEL_TERM = 'panel-term',
  PANEL_TERM_TEXT = 'panel-term-text',
  TEXT_TERM = 'text-term',
  TEXT_TERM_VALIDITY = 'text-term-validity',
  TEXT_WARNING = 'text-warning',
  TEXT_WARNING_VALIDITY = 'text-warning-validity',
}
export { PrivacyAliases };
